import axios from 'axios'
import auth from '../utils/auth'
import cfg from '../utils/config'

const generateGrantReport = async (payload) => {
    const userInfo = auth.getUserInfo()

    const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/ambiental/relatorio/outorgas/`
    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.getToken()}`
        }
    }

    try {
       const response = await axios.post(requestURL, payload, config)
        return response
    } catch (error) {
        console.error('Erro ao gerar o relatório de outorga: ', error)
        return {}
    }
}

export {
    generateGrantReport,
}
